import { useEffect, useRef } from "react";
import styled from "styled-components";
import Block, { BlockContent } from "~/components/Block";
import theme from "~/styles/theme";

// Public Join widget bundle. If you change Job Widget settings/design in Join,
// copy the new `src` from Settings → Job Widget → Embed code into this constant.
const JOIN_WIDGET_SRC =
  "https://join.com/api/widget/bundle/eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzZXR0aW5ncyI6eyJzaG93Q2F0ZWdvcnlGaWx0ZXIiOnRydWUsInNob3dMb2NhdGlvbkZpbHRlciI6dHJ1ZSwic2hvd0VtcGxveW1lbnRUeXBlRmlsdGVyIjp0cnVlLCJsYW5ndWFnZSI6ImVuIiwiam9ic1BlclBhZ2UiOjV9LCJqb2JzIjp7fSwiZGVzaWduIjp7InNob3dMb2dvIjp0cnVlLCJzaG93TG9jYXRpb24iOnRydWUsInNob3dFbXBsb3ltZW50VHlwZSI6dHJ1ZSwic2hvd0NhdGVnb3J5Ijp0cnVlLCJjb2xvcnMiOnsid2lkZ2V0Ijp7ImJhY2tncm91bmQiOiIjRkZGRkZGIiwiZmlsdGVyQm9yZGVyIjoiI0Q0RDREOCIsInBhZ2luYXRpb24iOiIjMjU2M0VCIn0sImpvYkNhcmQiOnsic2hhZG93IjoiI0Q0RDREOCIsImJhY2tncm91bmQiOiIjRkZGRkZGIiwicHJpbWFyeVRleHQiOiIjM0YzRjQ2Iiwic2Vjb25kYXJ5VGV4dCI6IiM1MjUyNUIifX19LCJ2ZXJzaW9uIjoyLCJjb21wYW55UHVibGljSWQiOiI0NzYxZGU1Y2Y2ZDAxODZhOGU1NTdmNWM4MGUzMmQyYSIsImlhdCI6MTc4ODI0NDM4NiwianRpIjoiYzVmM2RkNmQtM2RjNi00MzJmLWJmYmYtZDI5N2ExZDU5NmU3In0.DRHo-O3RH_hR6hlv6v8TZyPZ2SB1_DWW_gf-5E5ZYEg";

let joinWidgetInstance = 0;

const Mount = styled.div`
  min-height: 12rem;
  width: 100%;

  iframe {
    max-width: 100%;
  }
`;

type JoinJobsWidgetProps = {
  spacingTop?: number;
  spacingBottom?: number;
  backgroundColor?: string;
  color?: string;
};

export default function JoinJobsWidget(props: JoinJobsWidgetProps) {
  const {
    spacingTop = 6,
    spacingBottom = 8,
    backgroundColor = theme.colors.light,
    color = theme.colors.dark,
  } = props;

  const mountRef = useRef<HTMLDivElement>(null);
  const mountIdRef = useRef<string>();
  if (!mountIdRef.current) {
    joinWidgetInstance += 1;
    mountIdRef.current = `join-widget-${joinWidgetInstance}`;
  }
  const mountId = mountIdRef.current;

  useEffect(() => {
    const mount = mountRef.current;
    if (!mount) return undefined;

    const script = document.createElement("script");
    script.type = "text/javascript";
    script.src = JOIN_WIDGET_SRC;
    script.setAttribute("data-mount-in", `#${mountId}`);
    mount.appendChild(script);

    return () => {
      mount.innerHTML = "";
    };
  }, [mountId]);

  return (
    <Block
      spacingTop={spacingTop}
      spacingBottom={spacingBottom}
      backgroundColor={backgroundColor}
      color={color}
    >
      <BlockContent>
        <Mount id={mountId} ref={mountRef} />
      </BlockContent>
    </Block>
  );
}
